import { TTypeOfCodec, TTypeOfNewDefault } from "../../../shared/src/codecs/codec";
import { required } from "../../../shared/src/codecs/types/required";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { form } from "../../../shared/src/codecs/types/form";
import { EmptyObject } from "../EmptyObject";

export const ProbateGrantMatchActionForm = form(
    required({
        probate_grant_watch_id: uuid(),
    }),
    EmptyObject,
);

export type TProbateGrantMatchActionFormCodec = typeof ProbateGrantMatchActionForm;
export type TProbateGrantMatchActionForm = TTypeOfCodec<TProbateGrantMatchActionFormCodec>;
export type TProbateGrantMatchActionFormNewDefault = TTypeOfNewDefault<TProbateGrantMatchActionFormCodec>;
